export default "__VITE_ASSET__UjZnpOWR__"